import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import t, { createContext as o, useContext as a, useReducer as i } from "react";
import { drawerActions as w, DrawerReducer as d } from "./drawer.helpers";

var n = o({}),
    s = o({}),
    v = function v() {
  var e = a(n),
      r = a(s);
  return {
    drawerState: e,
    drawerActions: r
  };
},
    A = function A(_ref) {
  var e = _ref.children;

  var _i = i(d, {
    data: {}
  }),
      _i2 = _slicedToArray(_i, 2),
      r = _i2[0],
      c = _i2[1];

  return t.createElement(n.Provider, {
    value: r
  }, t.createElement(s.Provider, {
    value: w(r, c)
  }, e));
};

export { s as DrawerActionContext, A as DrawerProvider, n as DrawerStateContext, v as useDrawer };